import { type ApiRentVariant } from '@Model';
import {
    Card,
    Grid,
    GridColumns,
    type IGuiBinder,
    TextInput,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-10-21T09:12:12+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

interface IProps {
    binder: IGuiBinder<ApiRentVariant>;
}

export const RentVariantMainSection = memo(function RentVariantMainSection({ binder }: IProps) {
    const i18n = useTranslate('');

    const labelField = useProp(binder, 'label');
    const shorthandField = useProp(binder, 'shorthand');
    const remarksField = useProp(binder, 'remarks');

    return (
        <Card name="PrimaryData" border="withoutBorder" label="Allgemeine Informationen">
            <Grid>
                <GridColumns spans={[6, 6, 12]}>
                    <TextInput {...labelField} label={i18n('Bezeichnung')} />
                    <TextInput {...shorthandField} label={i18n('Suchcode')} />
                    <TextInput {...remarksField} inputSize={3} label={i18n('Bemerkung')} />
                </GridColumns>
            </Grid>
        </Card>
    );
});
